export const ratecurrency = {
  currency: {
    currencyTitle: 'Fiche de la devise {{name}}',
    detailsColumns: {
      cours: 'Cours',
      last_update: 'Dernière mise à jour',
      update_timestamp: 'Date',
    },
    header: {
      title: 'Liste des devises',
    },
    columns: {
      cours: 'Cours',
      name: 'Nom',
      favorite: 'Favoris',
      update_timestamp: 'Dernière mise à jour',
      code: 'Code',
    
    },
    modal: {
      message: 'Voulez-vous mettre comme favori',
      message_unfav: 'Vous ne voulez plus comme favori',
    },
  },
  rates: {
    rateTitle: 'Fiche du taux directeur {{name}}',
    detailsColumns: {
      cours: 'Cours',
      last_update: 'Dernière mise à jour',
      update_timestamp: 'Date',
    },
    header: {
      title: 'Liste des taux directeurs',
    },
    columns: {
      cours: 'Cours',
      name: 'Nom',
      favorite: 'Favoris',
      update_timestamp: 'Dernière mise à jour',
    },
    modal: {
      message_fav: 'Voulez-vous mettre comme favori',
      message_unfav: 'Vous ne voulez plus comme favori',
    },
  },

    placeholder:{
        add_favory:"Mettre en favori",
        remove_favory:"Retirer des favoris"
      }

};
